import React from 'react';
import PropTypes from 'prop-types';
import DateInputBase from './DateInputBase';

const DateInput = props => {
  const getStyles = type => {
    // .MuiIconButton-label-330
    // Calendar-calendarControlButton
    switch (type) {
      case 'serviceInitation':
        return {
          root: {
            width: '100%',
            maxWidth: '300px',
            backgroundColor: '#F6F5FA',
          },
          inputRoot: {
            maxWidth: '300px',
            paddingLeft: '7px',
            width: '100%',
          },
          formControl: {
            transform: 'translate(0, 16px) scale(1)',
          },
          calendarControlButton: {
            color: 'white',
          },
          calendarControlMonth: {
            color: 'white',
          },
        };
      case 'messaging':
        return {
          root: {
            width: 150,
            backgroundColor: '#F6F5FA',
          },
          inputRoot: {
            maxWidth: '150px',
            paddingLeft: '7px',
            width: 150,
          },
          formControl: {
            transform: 'translate(0, 16px) scale(1)',
          },
          calendarControlButton: {
            //       backgroundColor:'black',
            color: 'white',
          },
          calendarControlMonth: {
            color: 'white',
          },
        };
      case 'landing':
        return {
          root: {
            width: 200,
            backgroundColor: '#F6F5FA',
            margin: 0,
          },
          inputRoot: {
            maxWidth: '200px',
            paddingLeft: '7px',
            width: 200,
          },
          formControl: {
            transform: 'translate(0, 16px) scale(1)',
          },
          formLabel: {
            color: 'rgba(0, 0, 0, 0.54)',
          },
          calendarControlButton: {
            color: 'white',
          },
          calendarControlMonth: {
            color: 'white',
          },
        };
      default:
        return {};
    }
  };

  const { styleType, ...otherProps } = props;
  const styles = getStyles(styleType);
  return <DateInputBase styles={styles} {...otherProps} />;
};

DateInput.propTypes = {
  /** Pre-defined custom styles to override DropdownBase */
  styleType: PropTypes.string,
  /** Classname to be applied to <TextField> */
  className: PropTypes.string,
  /** If `true`, the input will not have an underline. */
  disableUnderline: PropTypes.bool,
  /** If `true`, textfield will be in error state */
  hasError: PropTypes.bool,
  /** Override or extend default styles */
  styles: PropTypes.object,
  /** Name attribute of the `input` element. */
  name: PropTypes.string.isRequired,
  /** Value of `input` element */
  value: PropTypes.any,
  /** Text used for input label */
  label: PropTypes.string,
  /** If `true`, the label is displayed as required. */
  required: PropTypes.any,
  /** Callback fired when value is changed */
  onChange: PropTypes.func,
};

DateInput.defaultProps = {
  styleType: 'default',
  hasError: false,
  disableUnderline: true,
};

export default DateInput;
